import { cn } from "@/lib/utils";
import { formatNumero } from "./cidades";

/** Número grande com rótulo, ao lado do mapa no modo TV. */
export function DestaqueTv({ rotulo, valor, discreto }: { rotulo: string; valor: number; discreto?: boolean }) {
  return (
    <div>
      <p className={cn("font-semibold tabular-nums", discreto ? "text-4xl text-slate-300" : "text-6xl")}>
        {formatNumero(valor)}
      </p>
      <p className="text-xl text-slate-400">{rotulo}</p>
    </div>
  );
}
